var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectTrait from "../Decorators/objectTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import { traitClass } from "../Trait";
import mixTraits from "../mixTraits";
import AutoRefreshingTraits from "./AutoRefreshingTraits";
import CatalogMemberTraits from "./CatalogMemberTraits";
import EnumDimensionTraits from "./DimensionTraits";
import FeatureInfoUrlTemplateTraits from "./FeatureInfoTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import TableTraits from "./Table/TableTraits";
import UrlTraits from "./UrlTraits";
let OpenDataSoftCatalogItemTraits = (_dec = traitClass({
  description: "Creates one catalog item from url that points to an opendatasoft service.",
  example: {
    url: "https://data.bmcc.nsw.gov.au",
    type: "opendatasoft-item",
    datasetId: "bicycle-network-blue-mountains",
    name: "opendatasoft-item example",
    id: "some unique id"
  }
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Dataset ID",
  description: "OpenDataSoft Dataset id (`dataset_id`)."
}), _dec3 = primitiveTrait({
  type: "string",
  name: "Geo point 2d field name",
  description: "Field to use as geo point 2d (i.e. lat long)."
}), _dec4 = primitiveTrait({
  type: "string",
  name: "Datetime field name",
  description: "Field to use as datetime."
}), _dec5 = primitiveTrait({
  type: "string",
  name: "Color field name",
  description: "Field to use as color."
}), _dec6 = primitiveTrait({
  type: "string",
  name: "Region field name",
  description: "Field to use as region mapping."
}), _dec7 = primitiveTrait({
  type: "string",
  name: "Select field",
  description: "Names of fields to 'select' when downloading data"
}), _dec8 = primitiveTrait({
  type: "string",
  name: "Group by field",
  description: "Names of fields to 'groupBy' when downloading data"
}), _dec9 = objectTrait({
  type: EnumDimensionTraits,
  name: "Available fields",
  description: "Names of fields which can be 'selected'"
}), _dec0 = primitiveTrait({
  type: "string",
  name: "Aggregate time values",
  description: "Aggregate time values (eg 1 day). See https://help.opendatasoft.com/apis/ods-search-v2/#group-by-clause"
}), _dec1 = primitiveTrait({
  type: "string",
  name: "Refresh interval template",
  description: 'Template used to calculate refresh interval based on Opendatasoft dataset object. This template is rendered using dataset JSON object as view. For example `"{{metas.custom.update-frequency}}"` will use `"update-frequency"` custom metadata property. This supports "human readable" time strings - for example "15 minutes" and "60 sec".'
}), _dec(_class = (_class2 = class OpenDataSoftCatalogItemTraits extends mixTraits(AutoRefreshingTraits, TableTraits, FeatureInfoUrlTemplateTraits, UrlTraits, CatalogMemberTraits, LegendOwnerTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "datasetId", _descriptor, this);
    _initializerDefineProperty(this, "geoPoint2dFieldName", _descriptor2, this);
    _initializerDefineProperty(this, "timeFieldName", _descriptor3, this);
    _initializerDefineProperty(this, "colorFieldName", _descriptor4, this);
    _initializerDefineProperty(this, "regionFieldName", _descriptor5, this);
    _initializerDefineProperty(this, "selectFields", _descriptor6, this);
    _initializerDefineProperty(this, "groupByFields", _descriptor7, this);
    _initializerDefineProperty(this, "availableFields", _descriptor8, this);
    _initializerDefineProperty(this, "aggregateTime", _descriptor9, this);
    _initializerDefineProperty(this, "refreshIntervalTemplate", _descriptor0, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "datasetId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "geoPoint2dFieldName", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "timeFieldName", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "colorFieldName", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "regionFieldName", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "selectFields", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "groupByFields", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "availableFields", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "aggregateTime", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "refreshIntervalTemplate", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class);
export { OpenDataSoftCatalogItemTraits as default };